import { ENDPOINTS } from '@philips-emr/hpms-health-insurance-commons';
import { ThemeColor, ThemeTonalRange } from '@philips-emr/tws-constants';
import { ConfigurationService, HttpService, LocaleService, MessageService, ThemeService } from '@philips-emr/tws-core/lib/services';
import { HttpMethod } from '@philips-emr/tws-core/lib/services/http-service';
import { applicationContext, foundationContext, Information } from '@philips-emr/tws-foundation/lib/context';

import { RootRoutes } from '../codegen';
import { Configuration, Wsuite } from '../services/configuration';

import { setupModules } from './modules';

interface Theme {
  dsColorRange: ThemeColor;
  dsAccentColor: ThemeColor;
  dsNavTonalRange: ThemeTonalRange;
  dsLoginTonalRange: ThemeTonalRange;
}

function map(obj: object): Information {
  const { body } = obj as any;

  return body;
}

function bootstrap(): Promise<void> {
  ConfigurationService.setAuthenticationConfiguration({
    clientId: 'healthInsurance',
    endpointMappers: {
      // @ts-ignore
      information: map,
    },
    endpoints: {
      information: {
        url: ENDPOINTS.GET.INFORMATION,
        method: HttpMethod.GET,
      },
      refresh: {
        url: ENDPOINTS.POST.REFRESH,
        method: HttpMethod.POST,
      },
      revoke: {
        url: ENDPOINTS.POST.REVOKE,
        method: HttpMethod.POST,
      },
    },
    inactivity: {
      time: 15 * 60 * 1000,
    },
    routes: {
      custom: [
        RootRoutes.HEALTH_DECLARATION_LANDING_ROUTE,
        RootRoutes.HEALTH_DECLARATION_INVALID_ROUTE,
        RootRoutes.HEALTH_DECLARATION_VALID_ROUTE,
        RootRoutes.HEALTH_DECLARATION_DYNAMIC_FORM,
        RootRoutes.HEALTH_DECLARATION_FINALIZATION_ROUTE,
        RootRoutes.HEALTH_DECLARATION_CANCELATION_ROUTE,
        RootRoutes.DESCREDITED_PROVIDER_ROUTE,
        RootRoutes.PRODUCTS_BY_USER_ROUTE,
      ],
      forgotPassword: '',
      home: RootRoutes.REDIRECT_ROUTE,
      inactivity: RootRoutes.INACTIVITY_ROUTE,
      login: RootRoutes.LOGIN_ROUTE,
    },
  });

  setupModules();

  applicationContext.setTitle(MessageService.msg('hi.title'));
  foundationContext.setCanEditSector(false);
  foundationContext.setCanEditProfile(false);
  foundationContext.setCanEditEstablishment(false);
  foundationContext.setShowEstablishment(false);
  foundationContext.setShowSector(false);

  const wsuite = HttpService.get<Wsuite>(ENDPOINTS.GET.WSUITE)
    .then((response: any) => {
      const wsuiteResponse = response.body || {} as Wsuite;

      let { dsColorRange, dsAccentColor, dsNavTonalRange, dsLoginTonalRange } = response.body as Theme;

      dsColorRange = dsColorRange || ThemeColor.GREEN;
      dsAccentColor = dsAccentColor || ThemeColor.AQUA;
      dsLoginTonalRange = dsLoginTonalRange || ThemeTonalRange.ULTRA_LIGHT;
      dsNavTonalRange = dsNavTonalRange || ThemeTonalRange.BRIGHT;

      ThemeService.setColors(dsColorRange, dsAccentColor as any);
      ThemeService.setContentTonalRange(dsLoginTonalRange);
      ThemeService.setNavigationTonalRange(dsNavTonalRange);
      Configuration.setTonalRange(dsLoginTonalRange);

      return wsuiteResponse;
    });

  LocaleService.init({ defaultLocale: 'pt-BR', supportedLocales: ['pt-BR'] });

  Configuration.setFileuploaderConfig();

  Configuration.setData(wsuite);
  return Promise.all([wsuite]).then(() => Promise.resolve());
}

export {
  bootstrap,
};
